import { RootAction, RootState } from '@src/app/_redux';
import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { clearSessionState } from '@src/app/_global/utility/persistedStorage';
import { USER_LOGOUT } from '@src/app/header/actions';
import { actionCreators as gaActionCreators } from '@src/app/analytics/googleAnalytics/actions';
import { actionCreators } from '@src/app/header/actions';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

export const clearAWSCreds = (
    action$: ActionsObservable<RootAction>,  
    state$: StateObservable<RootState>) =>
  action$.pipe(
    ofType(USER_LOGOUT),
    mergeMap(() => {
      const clientConfig = state$.value.clientConfig.clientConfig;
      const adminConfig = state$.value.adminConfig.adminConfig;

      let defaultMagClientProperty;
      let tableName = 'ClientProperties';
      if (adminConfig[clientConfig.magCode]) {
        defaultMagClientProperty = adminConfig[clientConfig.magCode][tableName];
      }

      // remove next line after adding complete persistence
      clearSessionState();
      gaActionCreators.createGAEvent({ 
        category: 'Logout', 
        action: 'Successful',
        label: defaultMagClientProperty.ProductType === 'Core' ? clientConfig.globalCode : clientConfig.magCode, 
      });
      actionCreators.userLogoutSuccessNotification();
      return of(actionCreators.userLogoutSuccess());
    }),
  );
